module.exports = __webpack_public_path__ + "img/Beg3.0f07a4d8.jpg";